// tslint:disable no-any
import * as React from 'react'
import { T } from '@homeschooling/sdk'
import m from 'moment-timezone'
import { Helper } from '../../Components/Helpers'

import defaultAva from '../../Components/brand/default_ava.svg'
import Persistence from '../Persistence'

export interface Props {
    children?: React.ReactNode,
    student: T.Student,
    event: T.Schedule,
    date?: string
}

Persistence.setValues()

export class ScheduleTile extends React.PureComponent<Props> {
  public static defaultProps = {
    helperErrors: false,
  }

  /*constructor (props: Props) {
    super(props)
  }*/

  public render (): React.ReactNode {

    const { event, date } = this.props

    let timedate = date ? date : m().format('YYYY-MM-DD')

    const student = event.students ? event.students[0] : {name: ''}
    let start_time = Helper.formatTime(`${timedate} ${event.starts_at}`, event.tz)
    let end_time = Helper.formatTime(`${timedate} ${event.ends_at}`, event.tz, 'h:mm a')

    let ava = false ? 'img' :  defaultAva
    
    /*
    <div className='flex items-center flex-none h-12'>
            <img className="object-cover w-10 h-10 rounded-full" src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=faceare&facepad=3&w=688&h=688&q=100" alt="student name" />
        </div>
        <div className='grow h-8 pl-2'>
            <div className='w-full h-4 font-light text-xs overflow-hidden text-gray-500'>{student.name}</div>
            <div className='w-full h-4 text-right captilize text-gray-700 font-semibold text-left text-xs overflow-hidden text-ellipsis'>{event.name}</div>
            <div className='w-full h-4 text-gray-600 font-normal text-right text-xs'>{start_time} - {end_time}</div>
        </div>
    */

    // In some scenarios (SelfSignupView) we need to show errors inline
    // with the form elements, so explicitly allow that option here.
      return (<React.Fragment>
        <div className='schedule-tile w-full flex flex-col'>
          <div className='w-full flex flex-row group'>
            <div className='flex flex-none'>
              <img className="object-cover bg-slate-600 w-10 h-10 rounded-full" src={ava} alt={student.name} />
            </div>
            <div className='w-full align-baseline grow pl-2 flex flex-col pt-1'>
              
                <div className='w-full overflow-hidden ellipsis items-center text-nowrap text-xs text-xs'>
                  <div className='w-full overflow-hidden ellipsis text-left text-sm font-bold'>
                    {event.name}  
                  </div>  
                </div>

                <div className='w-full overflow-hidden ellipsis items-center text-nowrap text-xs text-xs'>
                  <div className='w-full overflow-hidden ellipsis text-left text-xs'>
                    {start_time}-{end_time}  
                  </div>  
                </div>
              
            </div>
          </div>
          <div className='w-full text-xs py-2 text-gray-600'>
            {student.name}
          </div>
        </div>
      </React.Fragment>)

    
  }

}

export default ScheduleTile
